const loyaltyPointsService = {
    remove: function () {
        window.dispatchEvent(new CustomEvent('resetLoyaltyPoints', {
            bubbles: true,
            detail: {
                reason: 'selection_changed',
                timestamp: new Date().toISOString(),
                refreshBalance: false
            }
        }));
    },
    disable: function () {
        window.dispatchEvent(new CustomEvent('disableLoyaltySlider', { 
            bubbles: true,
            detail: { 
                disabled: true
            } 
        }));
    },
    enable: function () {
        window.dispatchEvent(new CustomEvent('disableLoyaltySlider', { 
            bubbles: true,
            detail: { 
                disabled: false
            } 
        }));
    },
    udpateMaxApply: function (total) {
        window.dispatchEvent(new CustomEvent('loyaltyProjectTotalsChanged', {
            bubbles: true,
            detail: {
                totalItemPrice: total
            }
        }));
    }
}

export default loyaltyPointsService;